import { DmFilter } from '../api/client'
import ArwenDetailedListBox, { ArwenDetailedListBoxItem } from './inputs/ArwenDetailedListBox'

type Props = {
    selection?: DmFilter
    onChange: (newSelection: DmFilter) => void
}

export default function DmFilterComboBox({ selection, onChange }: Props) {
    const options: ArwenDetailedListBoxItem[] = [
        {
            id: DmFilter.All,
            title: 'All content',
            description: 'Show both comments and direct messages',
            disabled: false
        },
        {
            id: DmFilter.CommentsOnly,
            title: 'Comments only',
            description: 'Show only public comments (the default)',
            disabled: false
        },
        {
            id: DmFilter.DmsOnly,
            title: 'DMs only',
            description: 'Show only direct messages',
            disabled: false
        }
    ]

    const value: ArwenDetailedListBoxItem =
        options.find((option) => option.id === `${selection}`) || options[1]

    return (
        <div
            className=" text-gray-950 flex rounded-md shadow"
            data-tooltip-content="Filter by content type (comments vs DMs)"
            data-tooltip-id="tooltip-id"
        >
            <ArwenDetailedListBox
                onSelect={(option: ArwenDetailedListBoxItem) => {
                    const id = option.id as DmFilter
                    onChange(id)
                }}
                options={options}
                selected={value}
                widthClass="w-42"
                label="Filter by content type (comments vs DMs)"
            />
        </div>
    )
}